import { useTranslation } from 'next-i18next'
import React from 'react'

import Layouts from '@/layouts/Layouts'
import WorldMaps from '@/modules/investment/why-invest/WorldMaps'

import Banner from './Banner'
import InfrastructureConnectivity from './InfrastructureConnectivity'
import Regulations from './Regulations'

const WhyInvest: React.FC = () => {
  const { t } = useTranslation()

  const handleToSectionTwo = () => {
    const element = document.getElementById('world')
    element?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <Layouts
      title={String(t('investment-why-invest:title'))}
      description={String(t('investment-why-invest:description'))}
    >
      <div className='min-h-screen w-full bg-white pt-14 lg:pt-18'>
        <div className='overflow-hidden'>
          <Banner handleToSectionTwo={handleToSectionTwo} />
          <div id='world'>
            <WorldMaps />
          </div>
          <InfrastructureConnectivity />
          <Regulations />
        </div>
      </div>
    </Layouts>
  )
}

export default WhyInvest
